import { NgModule } from '@angular/core';

import { Routes, RouterModule } from '@angular/router';
import { ErrorComponent } from '../shared/error/error.component';
import { CoreComponent } from './core.component';

const routes: Routes = [
    {
        path: ':lang',
        component: CoreComponent,
        children: [
            {
                path: 'alunos',
                loadChildren: () =>
                    import('../modules/alunos').then((s) => s.AlunosModule),
            },
            {
                path: 'questionario/:token',
                loadChildren: () =>
                    import('../modules/questionario').then((s) => s.QuestionarioModule),
            },
            { path: 'erro', component: ErrorComponent }
        ],
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class CoreRoutingModule {}
